// extracted by mini-css-extract-plugin
var _1 = "container--KUqw2";
var _2 = "loading--kP3Je";
export { _1 as "container", _2 as "loading" }
